import retailDeletedFullcont from './retailDeleted-fullcont.html'

const fullcontEntity = require('../../../../../components/fullcont/fullcont-entity')
const fullcontHandler = require('../../../../../components/fullcont/fullcont-handler')
const retailDeletedMenu = require('./retailDeleted-menu')
const handler = require('./retailDeleted-fullcont-handler')
const { form, formCopy } = require('./retailDeleted-fullcont-form')
const { retailDeletedMT } = require('./retailDeleted-fullcont-multitable')

const htmlFc = {}
let HTMLwasSelected = false

function HTMLselect() {
      fullcontHandler.HTMLselect(
            'retailDeleted',
            'retailDeleted',
            'retailDeleted-fullcont',
            retailDeletedFullcont,
            form,
            formCopy,
            retailDeletedMT,
            readOnlyAction,
            readOnlyAction,
            undefined,
            htmlFc,
      )

      htmlFc.selectOne = 'server/php/sql/retailDeletedSelectOne.php'
      htmlFc.fullcontHTML.classList.add('mode-readOnly', 'mode-view')
      HTMLwasSelected = true
}

export function start(detail) {
      if (!HTMLwasSelected) { HTMLselect() }

      const action = actions[detail.act]
      if (action) { action(detail) }
}

const actions = {
      fullcontOptions: (detail) => { retailDeletedMenu.start(detail, htmlFc) },
      hide: (detail) => { fullcontEntity.hide(detail, htmlFc) },
      restore: () => { handler.restoreRetail(htmlFc) },
      selectOne: (detail) => {
            fullcontEntity.selectOne(detail, htmlFc, processAfterSelectOne)
      },
}

function processAfterSelectOne(data, result) {
      handler.renderChanges(result, htmlFc)
      handler.enforceReadOnly(htmlFc)
}

function readOnlyAction() {
      return false
}
